
export enum FolderTypeIconEnum {
    default,
    sharepointFolder,
    sharepointSite,
    documentLibrary,
    oneDrive,
    oneDriveSubFolder,
    teamChannel,
    teamMainSite,
    teamFolder,
    sharepointDocumentSet,
    sharepointList,
    sharepointHubSite
}
